import React, { useContext, useEffect } from 'react';

import Message from './Message';
import SocketClientContext from '../contexts/SocketClient';
import { USER_NAME_STORAGE_KEY } from './UserNameModal';
import { getInitiativeName, USER_VIEWS } from '../api';
import { useGlobalState } from '../state';

function sendLastSeenMessageId(socketClient, messages, currentChannel) {
  if (!messages) {
    return;
  }

  const lastSeenId = messages
    .slice(0)
    .sort((a, b) => b.id - a.id)[0].id
  socketClient.send(USER_VIEWS, {}, JSON.stringify({
    user: localStorage.getItem(USER_NAME_STORAGE_KEY),
    workspace: getInitiativeName(),
    channel: currentChannel,
    messageId: lastSeenId
  }));
}

function MessageList() {
  const [messagesByChannel,] = useGlobalState('messagesByChannel')
  const [currentChannel,] = useGlobalState('currentChannel');
  const messages = messagesByChannel && messagesByChannel[currentChannel]
  const socketClient = useContext(SocketClientContext);

  useEffect(() => {
    sendLastSeenMessageId(socketClient, messages, currentChannel);
  }, [messages, currentChannel, socketClient]);

  return (
    <div style={{ width: '100%' }}>
      {messages && messages.map(value =>
        <Message
          key={`${value.id}-${value.type}-${value.branch}`}
          value={value}
        />)}
    </div>
  );
}

export default MessageList;
